import { useDispatch } from 'react-redux';
import ComplainsForm from '../../common/ComplainsForm/ComplainsForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import {
  editAreaRequest,
  loadAreaByIdRequest,
} from '../../../redux/areasRedux';
import {
  editAdditionalDesRequest,
  loadAdditionalDesByIdRequest,
} from '../../../redux/additionalDesRedux';
import { useTranslation } from 'react-i18next';
const EditAdditionalDesForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [area, setArea] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadAdditionalDesByIdRequest(id));
      setArea(res.data);
      setLoading(false);
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (data) => {
    await dispatch(editAdditionalDesRequest({ ...data, id }));
    navigate('/dodatkowy-opis');
  };

  if (!loading) {
    return (
      <ComplainsForm
        action={handleSubmit}
        {...area}
        actionText={t('pz05.incompatibilities.addDes.editForm')}
        buttonText={t('button.edit')}
      />
    );
  }
};

export default EditAdditionalDesForm;
